// Centralized application route constants
// Prefer importing from this module instead of hardcoding strings

export const ROUTES = {
  order: {
    overview: '/orders/overview',
    statistics: '/orders/statistics',
    import: '/orders/import',
    importSimplified: '/orders/import-simplified',
  },
  product: {
    overview: {
      root: '/product-overview',
      management: '/product-overview/management',
      stock: '/product-overview/stock',
      statistics: '/product-overview/statistics',
      import: '/product-overview/import',
      importStock: '/product-overview/import-stock',
      importPending: '/product-overview/import-pending',
      import3PL: '/product-overview/import-3pl',
    },
  },
  expiry: {
    expiringSoon: '/product-overview/expiry', // 快到期產品（到期日總表）
    expiryProcessing: '/product-overview/expiry-processing', // 到期日處理
    bestExpiryImport: '/product-overview/best-expiry-import', // 匯入功能(最佳使用日期)
  },
  company: {
    management: '/company-management',
    selection: '/company-selection',
  },
  dashboard: {
    root: '/dashboard',
  },
  analytics: {
    salesAnalysis: '/analytics/sales-analysis',
    slowMoving: '/analytics/slow-moving',
    trafficAnalysis: '/analytics/traffic-analysis',
    priceAnalysis: '/analytics/price-analysis',
  },
  purchase: {
    ruleSettings: '/purchase/rule-settings',
    suggestedOrders: '/purchase/suggested-orders',
    crossCompanySuggestions: '/purchase/cross-company-suggestions',
  },
  auth: {
    login: '/login',
    register: '/register',
    resetPassword: '/reset-password',
  },
  hq: {
    purchasing: '/hq/purchasing',
    wholesale: '/hq/wholesale',
    accounting: '/hq/accounting',
  },
} as const;

export type AppRoute = typeof ROUTES[keyof typeof ROUTES];


